exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multiselect__placeholder{padding-top:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-07e25fbd!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/DynamicPricingAssignRuleToProductComponent.vue
// module id = 838
// module chunks = 2